export default "__VITE_PUBLIC_ASSET__16537b84__"